"use strict";
// Cabecera: sticky al hacer scroll + sincroniza el selector de IVA si existe.
// Lo cargan sections/mtn-header.liquid y sections/gr-header.liquid.
// US no tiene selector de IVA en la cabecera: antes el script daba por hecho
// que #mob_vat_toggle / #inc_vat / #ex_vat existian, fallaba (TypeError) y no
// llegaba a llamar a gr_vat_updatePrices(), asi que los precios con la clase
// gr-vat-price-defer se quedaban transparentes. Ahora cada elemento es opcional.
(() => {
  const body = document.body;
  const header = document.querySelector(".gr-section-header");

  if (header && typeof stickyHeader !== "undefined" && stickyHeader) {
    header.classList.add("gr-sticky-header");
    const headerBottom = () => header.getBoundingClientRect().top + header.clientHeight;
    const UP = "gr-scroll-up";
    const DOWN = "gr-scroll-down";
    let lastY = 0;
    window.addEventListener("scroll", () => {
      const y = window.pageYOffset;
      if (y <= headerBottom()) {
        body.classList.remove(UP);
        return;
      }
      if (y > lastY && !body.classList.contains(DOWN)) {
        body.classList.remove(UP);
        body.classList.add(DOWN);
      } else if (y < lastY && body.classList.contains(DOWN)) {
        body.classList.remove(DOWN);
        body.classList.add(UP);
      }
      lastY = y;
    }, { passive: true });
  }

  if (window.gr_vat_getState && window.gr_vat_updatePrices) {
    const mobToggle = document.getElementById("mob_vat_toggle");
    const incVat = document.getElementById("inc_vat");
    const exVat = document.getElementById("ex_vat");

    if (mobToggle && incVat && exVat) {
      if (window.gr_vat_getState()) {
        incVat.checked = true;
        mobToggle.checked = true;
      } else {
        exVat.checked = true;
        mobToggle.checked = false;
      }
      mobToggle.addEventListener("change", () => {
        window.gr_vat_setState(mobToggle.checked);
        (mobToggle.checked ? incVat : exVat).checked = true;
      });
      incVat.addEventListener("change", () => {
        window.gr_vat_setState(true);
        mobToggle.checked = true;
      });
      exVat.addEventListener("change", () => {
        window.gr_vat_setState(false);
        mobToggle.checked = false;
      });
    }

    // Siempre, haya selector o no: quita gr-vat-price-defer y muestra los precios.
    window.gr_vat_updatePrices();
  }
})();
